import React from 'react';

interface CountdownDisplayProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  compact?: boolean;
}

const pad = (n: number) => String(Math.max(0, n)).padStart(2, '0');

const CountdownDisplay: React.FC<CountdownDisplayProps> = ({ days, hours, minutes, seconds, compact }) => {
  if (compact) {
    return (
      <span className="font-mono font-bold text-sm text-gradient-mc">
        {pad(days)}d {pad(hours)}h {pad(minutes)}m {pad(seconds)}s
      </span>
    );
  }

  const cells: Array<[number, string]> = [
    [days, 'días'],
    [hours, 'horas'],
    [minutes, 'min'],
    [seconds, 'seg'],
  ];

  return (
    <div className="flex items-stretch gap-2.5">
      {cells.map(([value, label]) => (
        <div key={label} className="chip-mc rounded-xl px-3 py-2 text-center">
          <div className="font-mono font-bold text-2xl text-gradient-mc">{pad(value)}</div>
          <div className="text-[10px] uppercase tracking-wider text-white/50">{label}</div>
        </div>
      ))}
    </div>
  );
};

export default CountdownDisplay;
